import React from "react";

import { cn } from "lib/utils";

import { SkeletonHeading, SkeletonButton } from "./SkeletonPrimitives";

type PageLoadingContainerProps = {
  showSkeleton: boolean;
  children: React.ReactNode;
  headerSkeleton?: React.ReactNode;
  contentSkeleton?: React.ReactNode;
  slowState?: React.ReactNode;
  className?: string;
  ariaLabel?: string;
  actionsSkeleton?: React.ReactNode;
};

const DEFAULT_HEADER_SKELETON = (
  <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
    <SkeletonHeading />
    <SkeletonButton className="w-40" />
  </div>
);

const PageLoadingContainer = ({
  showSkeleton,
  children,
  headerSkeleton = DEFAULT_HEADER_SKELETON,
  contentSkeleton,
  slowState,
  className,
  ariaLabel = "Cargando contenido...",
  actionsSkeleton,
}: PageLoadingContainerProps) => {
  if (!showSkeleton) {
    return <div className={className}>{children}</div>;
  }

  return (
    <section
      className={cn(
        "flex flex-col gap-6 rounded-2xl border border-slate-200/70 bg-white/95 p-6",
        className,
      )}
      role="status"
      aria-live="polite"
      aria-label={ariaLabel}
      aria-busy="true"
      data-testid="page-loading-container"
    >
      <span className="sr-only">{ariaLabel}</span>
      {slowState}
      <div className="space-y-4">
        {headerSkeleton}
        {actionsSkeleton}
      </div>
      {contentSkeleton}
    </section>
  );
};

export default PageLoadingContainer;
